import { useSetAtom } from "jotai";
import { userProfileStateAtom } from "../../../features/Profile/atoms";
import { useEffect } from "react";
import { iProfile } from "../../../features/Profile";
import { brandShadowSm, customColorTokens } from "../../../../tamagui.config";

import { View, ScrollView, Text, YStack, Button } from "tamagui";

import { Header } from "../../../components/design-system/Header";

import { Linking, RefreshControl } from "react-native";
import { useQueryClient } from "@tanstack/react-query";

import { PartnersList } from "../features/PartnersList/PartnersList";
import { ClubLogo } from "../../../components/ClubLogo";
import { useApiQuery } from "../../../../lib/api";
import { useAtomValue } from "jotai";
import { currentUserAtom } from "../../../../atoms/global";
import { Loader } from "../../../components/design-system/Loader";
import type { Profile } from "../../../types/profile";

export const ClubScreenQueryRenderer = () => {
  const user = useAtomValue(currentUserAtom);

  const queryClient = useQueryClient();

  const { data, isLoading, refetch, isRefetching } = useApiQuery<{ profile: Profile }>(
    ["profile", user?.id],
    `/api/v1/profiles/${user?.id}`,
    { enabled: !!user?.id }
  );

  const handleRefresh = async () => {
    await Promise.all([
      refetch(),
      queryClient.invalidateQueries({ queryKey: ["partners"] }),
    ]);
  };

  const profile = data?.profile;
  const setProfileState = useSetAtom(userProfileStateAtom);

  useEffect(() => {
    if (profile) {
      setProfileState({ ...profile } as iProfile);
    }
  }, [profile, setProfileState]);

  const userRole = profile?.roles?.[0]?.role;

  const formatRole = (role: string) => {
    return role.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  if (isLoading) return <Loader />;

  return (
    <View
      flex={1}
      style={{ flex: 1, backgroundColor: customColorTokens.brandYellow }}
    >
      <Header title="Membership" />

      <ScrollView
        flex={1}
        bg={customColorTokens.brandParchment}
        contentContainerStyle={{
          backgroundColor: customColorTokens.brandParchment,
          paddingBottom: 100,
        }}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl refreshing={isRefetching} onRefresh={handleRefresh} />
        }
      >
        <View flex={1}>
          <ScrollView pt="$4">
            <YStack flex={1}>
              <YStack
                gap="$4"
                py="$2"
                position="relative"
                flex={1}
                bg="$brandParchment"
              >
                {userRole && userRole !== "Member" ? (
                  <YStack gap="$6" px="$4" jc="center" alignItems="center">
                    <ClubLogo width="60%" height={100} color="black" />

                    <Text
                      width="100%"
                      fontSize={16}
                      textTransform="uppercase"
                      fontFamily="$heading"
                    >
                      Partners & Perks
                    </Text>

                    <PartnersList />
                  </YStack>
                ) : (
                  <YStack
                    flex={1}
                    bg="$brandParchment"
                    alignItems="center"
                    justifyContent="center"
                    gap="$4"
                  >
                    <Text fontSize={20}>Want to become a paid member?</Text>
                    <Button
                      bg="$brandYellow"
                      {...brandShadowSm}
                      borderWidth={1}
                      borderColor="black"
                      onPress={() =>
                        Linking.openURL("https://breakfastclubatx.com/club")
                      }
                      fontFamily="$heading"
                      fontSize={16}
                    >
                      JOIN THE CLUB
                    </Button>
                  </YStack>
                )}
              </YStack>
            </YStack>
          </ScrollView>
        </View>
      </ScrollView>
    </View>
  );
};
